import { tickerItems } from '@/mocks/home';

export default function HotTicker() {
  const loopItems = [...tickerItems, ...tickerItems];

  return (
    <section className="border-y border-background-200 bg-background-100/70">
      <div className="mx-auto flex w-full max-w-[1280px] items-center gap-4 px-4 py-4 md:px-8">
        <span className="flex shrink-0 items-center gap-2 rounded-full bg-primary-500 px-3.5 py-1.5 text-xs font-medium text-background-50">
          <span className="flex h-3.5 w-3.5 items-center justify-center">
            <i className="ri-live-line text-xs" />
          </span>
          实时速览
        </span>

        <div className="relative hidden flex-1 overflow-hidden md:block">
          <div className="flex w-max animate-marquee items-center gap-8 whitespace-nowrap">
            {loopItems.map((item, index) => (
              <span key={`${item}-${index}`} className="flex items-center gap-3 text-sm text-foreground-700">
                <span className="flex h-3.5 w-3.5 items-center justify-center">
                  <i className="ri-circle-fill text-[6px] text-accent-500" />
                </span>
                {item}
              </span>
            ))}
          </div>
        </div>

        <div className="flex-1 overflow-hidden md:hidden">
          <p className="truncate text-sm text-foreground-700">{tickerItems[0]}</p>
        </div>
      </div>
    </section>
  );
}